var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.083 4.584H1.917v10.833h16.166zM3.417 7.917V6.084h13.166v1.833zm0 1.5v4.5h13.166v-4.5z",
    clipRule: "evenodd"
  })));
};
export { SvgCreditCard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTguMDgzMyA0LjU4Mzk4SDEuOTE2NjZWMTUuNDE3M0gxOC4wODMzVjQuNTgzOThaTTMuNDE2NjYgNy45MTY5OVY2LjA4Mzk4SDE2LjU4MzNWNy45MTY5OUgzLjQxNjY2Wk0zLjQxNjY2IDkuNDE2OTlWMTMuOTE3M0gxNi41ODMzVjkuNDE2OTlIMy40MTY2NloiIC8+Cjwvc3ZnPgo=";